import axios             from "axios";
import {generatePath}    from "react-router";
import Entrypoint        from "../Entrypoint";
import {ResponsePromise} from "../ResponsePromise";


class NotificationApi {
  List(page?: any): ResponsePromise<{ current_page: number, total: number, data: any }> {
    return axios.get(process.env.REACT_APP_API_URL + Entrypoint.Api.Notification.Index, {
      params: {
        ...page,
      },
    });
  }

  Delete(notification: string): ResponsePromise<{ data: any }> {
    return axios.delete(process.env.REACT_APP_API_URL + generatePath(Entrypoint.Api.Notification.Delete, {notification}));
  }

  Get(notification: string): ResponsePromise<{ data: any }> {
    return axios.get(process.env.REACT_APP_API_URL + generatePath(Entrypoint.Api.Notification.Get, {notification}));
  }

  Patch(): ResponsePromise<{ data: any }> {
    return axios.patch(process.env.REACT_APP_API_URL + generatePath(Entrypoint.Api.Notification.Patch));
  }

  Total(): ResponsePromise<number> {
    return axios.get(Entrypoint.Api.Notification.Total);
  }
}


export default NotificationApi;
